import React, { useEffect, useRef, useState } from "react";
import useAuth from "../../../hooks/useAuth";
import { LapiService } from "../../../lib/lapi";

export type LapiImgProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

function OcrImg(props: LapiImgProps) {
  const { className, src, alt } = props;
  const { token } = useAuth();
  const [innerSrc, setInnerSrc] = React.useState<string>();
  const imgRef = useRef<HTMLImageElement>(null);
  const [scale, setScale] = useState(1);

  function getZoom(width: number, height: number) {
    const ratio = width / height;
    const distance = Math.abs(ratio - 1);

    const a = 1.6;
    const b = 0.18;

    const minZoom = 1.3;
    const maxZoom = 1.9;

    let zoom = a - b * distance;

    zoom = Math.max(minZoom, Math.min(maxZoom, zoom));

    return zoom;
  }

  useEffect(() => {
    if (src === undefined || token === undefined) return;

    let mounted = true;

    LapiService.getLapiImage(src, token)
      .then((lapiImage: any) => {
        if (mounted) setInnerSrc(lapiImage);
      })
      .catch((error: any) => {
        if (process.env.NODE_ENV !== "production") console.error(error);
      });

    return () => {
      mounted = false;
    };
  }, [src, token]);

  const handleImageLoad = (e: any) => {
    const img = e.target;

    const width = img.naturalWidth;
    const height = img.naturalHeight;

    const computedZoom = getZoom(width, height);
    setScale(computedZoom);
  };

  useEffect(() => {
    const img = imgRef.current;
    if (!img) return;

    const handleWheel = (e: WheelEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const delta = -e.deltaY / 500;
      const nextScale = Math.min(Math.max(scale + delta, 1), 5);

      setScale(nextScale);
    };

    img.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      img.removeEventListener("wheel", handleWheel);
    };
  }, [scale]);

  return (
    <div
      className={className}
      style={{
        overflow: "hidden",
        // backgroundColor: "#f5f5f5",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <img
        ref={imgRef}
        className={className}
        style={{
          objectPosition: "center",
          objectFit: "contain",
          transform: `scale(${scale})`,
          transformOrigin: "center",
          transition: "transform 0.3s ease",
        }}
        src={innerSrc}
        alt={alt}
        onLoad={handleImageLoad}
      />
    </div>
  );
}

export default OcrImg;
